import sample_01 from './dynamicBlazeReflect.jpg';

export const dynamicBlazeReflectImpressions = {
    sample_01,
};
